import type { GetAllPlansResponse } from '~/repository/modules/plan.module';
import type { AggregatedBundlePriceDto } from './ListingProduct.api.model';

export type Plan = {
  bundlePrices: AggregatedBundlePriceDto[];
  isFamilyAllowed: boolean;
  isFamilyPlan: boolean;
  parentPlanIds: number[] | null;
  planId: number;
  planName: string;
  productId: number;
  productAttributeCombinationId: number;
  productName: string;
  offerValidityInMonthsDataAmount?: number;
  offerValidityInMonthsDiscount?: number;
  offerValidityInMonthsFreePeriod?: number;
};

export const mapAllPlansResponseToPlans = (
  response: GetAllPlansResponse,
): Plan[] => {
  const plans: Plan[] = [];
  const products = response.Data;

  if (!products || !Array.isArray(products)) {
    return plans;
  }

  for (const product of products) {
    const variant =
      product.Variants && product.Variants.length > 0
        ? product.Variants[0]
        : undefined;

    if (
      !variant ||
      !variant.Prices.BundlePrices ||
      variant.Prices.BundlePrices.length === 0
    ) {
      continue;
    }

    const firstBundlePrice = variant.Prices.BundlePrices[0];

    if (!firstBundlePrice.Plan) {
      continue;
    }

    plans.push({
      bundlePrices: variant.Prices.BundlePrices,
      isFamilyAllowed: firstBundlePrice.Plan.IsFamilyAllowed,
      isFamilyPlan: firstBundlePrice.Plan.IsFamilyPlan,
      parentPlanIds: firstBundlePrice.Plan.ParentPlanIds ?? null,
      planId: firstBundlePrice.Plan.PlanId,
      planName: firstBundlePrice.Plan.PlanName,
      productId: product.ProductId,
      productAttributeCombinationId: variant.ProductAttributeCombinationId,
      productName: product.ProductName,
    });
  }

  return plans;
};

export const mapProductDataBundlePricesToPlanObject = (
  bundlePrices: AggregatedBundlePriceDto[] = [],
): Plan | null => {
  if (bundlePrices.length === 0) {
    return null;
  }

  const plan = bundlePrices.find((bp) => !!bp.Plan)?.Plan;
  if (!plan) {
    return null;
  }

  return {
    bundlePrices: bundlePrices,
    isFamilyAllowed: plan.IsFamilyAllowed,
    isFamilyPlan: plan.IsFamilyPlan,
    parentPlanIds: plan.ParentPlanIds || null,
    planId: plan.PlanId,
    planName: plan.PlanName,
    productId: -1,
    productAttributeCombinationId: -1,
    productName: '',
    offerValidityInMonthsDataAmount: plan.OfferValidityInMonthsDataAmount,
    offerValidityInMonthsDiscount: plan.OfferValidityInMonthsDiscount,
    offerValidityInMonthsFreePeriod: plan.OfferValidityInMonthsFreePeriod,
  };
};
